var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUserThisPlanner || (!_vm.isUserThisPlanner && _vm.planner != null))?_c('div',{},[(!_vm.isUserThisPlanner)?[_vm._v("\n       \n    "),_c('router-link',{staticClass:"no-underline inline-block hover:underline mb-4 text-sm text-black",attrs:{"to":{ name: 'planner-list' },"tag":"a"}},[_vm._v("Back to planner list")])]:_vm._e(),_c('div',{staticClass:"nav-box"},[_c('div',{staticClass:"nav-box-header"},[(_vm.isUserThisPlanner)?[_vm._v("\n        My Account\n      ")]:[_vm._v("\n        "+_vm._s(_vm.planner.first_name)+" "+_vm._s(_vm.planner.last_name)+"\n      ")]],2),_c('router-link',{class:{ 'nav-item mt-1' : true, 'selected' : _vm.$route.name == 'planner-account' },attrs:{"to":{
        name: 'planner-account',
        params : {
          plannerId : _vm.$route.params.plannerId
        }
      },"tag":"a"}},[(_vm.isUserThisPlanner)?[_vm._v("\n        My Details\n      ")]:[_vm._v("\n        Planner Details\n      ")]],2),_c('router-link',{class:{ 'nav-item' : true, 'selected' : _vm.$route.name == 'planner-password' },attrs:{"to":{
        name  : 'planner-password',
        params: {
          plannerId : _vm.$route.params.plannerId
        }
      },"tag":"a"}},[_vm._v("Password")]),_c('router-link',{class:{ 'nav-item' : true, 'selected' : _vm.$route.name == 'planner-site-appearance' },attrs:{"to":{
        name  : 'planner-site-appearance',
        params: {
          plannerId : _vm.$route.params.plannerId
        }
      },"tag":"a"}},[_vm._v("Site Appearance")]),_c('router-link',{class:{ 'nav-item' : true, 'selected' : _vm.$route.name == 'planner-mail-setting' },attrs:{"to":{
        name: 'planner-mail-setting',
        params: {
          plannerId: _vm.$route.params.plannerId
        }
      },"tag":"a"}},[_vm._v("Mail Settings")])],1)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }